<!--  -->
<template>
  <a-modal
    @cancel="modalClose"
    :visible="forgetModalVisible.visible"
    layout="horizontal"
    width="780px"
    wrapClassName="forget-pwd-modal"
    :footer="null"
  >
    <div class="forget-left-content">
      <div class="left-content-bd">
        <img src="~assets/modal/forget-pwd-left-bg-image.png" alt="">
      </div>
      <div class="left-content-ft">
        <div class="title">
          小初高英语考试必备线上课堂
        </div>
        <div class="desc">
          解锁更多英语知识技巧等
        </div>
      </div>
    </div>
    <div class="forget-right-content">
      <div class="right-top-circle"></div>
      <h2 class="form-modal-title">重置密码</h2>
      <a-form-model
        ref="forgetForm"
        :model="forgetForm"
        :rules="rules"
        class="forget-form">
        <a-form-model-item prop="username">
          <a-input
            v-model="forgetForm.username"
            autocomplete="off"
            placeholder="手机号"
            @focus="clearValidate('forgetForm', 'username')"
          >
            <template slot="prefix">
              <div class="label-prefix">
                <span>账号</span>
              </div>
            </template>
          </a-input>
        </a-form-model-item>
        <div class="yzm-cell">
        <a-form-model-item prop="code">
          <a-input
            v-model="forgetForm.code"
            autocomplete="off"
            placeholder="验证码"
            @focus="clearValidate('forgetForm', 'code')"
          >
            <template slot="prefix">
              <div class="label-prefix">
                <span>验证码</span>
              </div>
            </template>
          </a-input>
          <a-button
            type="primary"
            shape="round"
            :disabled="disabled"
            @click="getVerifyCode"
            class="yzm-btn"
          >{{ btnTitle }}
          </a-button
          >
        </a-form-model-item>
        </div>

        <a-form-model-item prop="password">
          <input type="text" autocomplete="new-password" class="false-input"/>
          <input type="password" autocomplete="new-password" class="false-input"/>
          <a-input
            v-model="forgetForm.password"
            :type="passType"
            ref="Password"
            autocomplete="off"
            placeholder="密码(6至12位数字或字母)"
            @focus="clearValidate('forgetForm', 'password')"
          >
            <template slot="prefix">
              <div class="label-prefix">
                <span>密码</span>
              </div>
            </template>
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="repasswd">
          <a-input
            v-model="forgetForm.repasswd"
            :type="rePassType"
            ref="RePassword"
            autocomplete="off"
            placeholder="再次输入密码"
            @focus="clearValidate('forgetForm', 'repasswd')"
          >
            <template slot="prefix">
              <div class="label-prefix">
                <span>确认密码</span>
              </div>
            </template>
          </a-input>
        </a-form-model-item>


        <div class="login-modal-submit-btn">
        <a-button
          type="primary"
          shape="round"
          size="large"
          block
          html-type="submit"
          @click="forgetSubmit"
        >
          重置密码
        </a-button>
        </div>

      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import mTypes from '@/store/mutationsTypes'
import { sendSms, resetPasswd, teacherResetPasswd } from '@/services'
import { Input, Modal, FormModel } from 'ant-design-vue'
import { validatePhone, validatePass } from '@/utils/form-validate'
import ROUTER_MAP from '@/router/router-map'

export default {
  name: 'forgetModal',
  components: {
    AInput: Input,
    AModal: Modal,
    AFormModel: FormModel,
    AFormModelItem: FormModel.Item
  },
  data () {
    return {
      passType: 'text',
      rePassType: 'text',
      forgetForm: {
        username: '',
        password: '',
        repasswd: '',
        code: '',
      },
      rules: {
        username: [{ validator: validatePhone, trigger: 'blur' }],
        password: [{ validator: validatePass, trigger: 'blur' }],
        code: { required: true, message: '请输入验证码' },
        repasswd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请重新输入密码'))
              } else if (value !== this.forgetForm.password) {
                callback(new Error('两次密码输入不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      disabled: false,
      btnTitle: '获取验证码'
    }
  },
  computed: {
    ...mapState({
      forgetModalVisible: state => state.forgetModalVisible
    })
  },
  watch: {},
  methods: {
    ...mapMutations([mTypes.forgetModal, mTypes.loginModal]),
    modalClose () {
      this[mTypes.forgetModal]({ visible: false })
    },
    forgetSubmit (e) {
      this.$refs.forgetForm.validate(async valid => {
        if (valid) {
          if (this.forgetModalVisible.type) {
            let res = await teacherResetPasswd({
              ...this.forgetForm
            })
            if (res.code === 1) {
              this.$message.success('重置密码成功')
              this[mTypes.forgetModal]({ visible: false })
            }
          } else {
            let res = await resetPasswd({
              ...this.forgetForm
            })
            if (res.code === 1) {
              this.$message.success('重置密码成功')
              this[mTypes.forgetModal]({ visible: false })
              this[mTypes.loginModal](true)
            }
          }
        }
      })
    },
    getVerifyCode (e) {
      this.$refs.forgetForm.validateField(['username'], async valid => {
        if (!valid) {
          this.validateBtn()
          let code = await sendSms({
            username: this.forgetForm.username,
            type: 3
          })
          console.log(code)
        }
      })
    },
    validateBtn () {
      //倒计时
      let time = 60
      this.disabled = true
      let timer = setInterval(() => {
        if (time == 0) {
          clearInterval(timer)
          this.disabled = false
          this.btnTitle = '获取验证码'
        } else {
          this.btnTitle = time + '秒后重试'
          this.disabled = true
          time--
        }
      }, 1000)
    },
    clearValidate (form, filed) {
      this.$refs[form].clearValidate(filed)
      if (filed === 'password') {
        this.passType = 'password'
      } else if (filed === 'repasswd') {
        this.rePassType = 'password'
      }
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeMount () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  activated () {
  }
}
</script>
<style lang="less">
.form-modal-title {
  font-size: 27.6px;
  text-align: center;
  color: #666666;
  font-weight: 700;
}

.forget-pwd-modal {
  .ant-modal-body {
    padding: 0 !important;
    display: flex;
    justify-content: center;
  }
}

.forget-left-content {
  display: block;
  height: 493px;
  width: 50%;
  background-color: rgba(245, 245, 245, 1);
  flex: 1;

  .left-content-bd {
    text-align: center;
    text-align: center;
    padding: 30px;
    padding-top:50px;
    box-sizing: border-box;
    img {
      width: 100%;
    }
  }

  .left-content-ft {
    text-align: center;
    .title {
      height: 45px;
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 45px;
    }

    .desc {
      height: 30px;
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
    }
  }
}

.forget-right-content {
  display: block;
  width: 50%;
  height: 493px;
  position: relative;
  flex: 1;
  padding:30px 30px;
  padding-top:80px;
  overflow: hidden;
}


.forget-form {
  position: relative;
  overflow: hidden;

  .false-input {
    position: absolute;
    right: -1000px;
  }

  .label-prefix {
    width: 80px;
  }
}
</style>
